module.exports = __webpack_public_path__ + "img/LOGO_NEXTGENERATIONEU.24d9c95f.jpg";